// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos para o React Big Calendar */
.rbc-calendar {
  font-family: 'Roboto', sans-serif;
}

.rbc-event {
  padding: 2px 5px;
  border-radius: 4px;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.1s;
  font-size: 0.85rem;
  border: none !important;
}

.rbc-event:hover {
  opacity: 0.9;
  transform: scale(1.02);
}

.rbc-event-label {
  font-size: 0.75rem;
}

.rbc-today {
  background-color: #e3f2fd !important;
}

.rbc-header {
  padding: 10px 5px;
  font-weight: 500;
  font-size: 0.9rem;
  border-bottom: 2px solid #e0e0e0;
}

.rbc-toolbar {
  padding: 10px 0;
  margin-bottom: 10px;
}

.rbc-toolbar button {
  color: #1976d2;
  border: 1px solid #1976d2;
  padding: 6px 12px;
  margin: 0 3px;
  border-radius: 4px;
  background-color: white;
  font-size: 0.875rem;
  transition: all 0.2s;
}

.rbc-toolbar button:hover {
  background-color: #e3f2fd;
  border-color: #1565c0;
}

.rbc-toolbar button:active,
.rbc-toolbar button.rbc-active {
  background-color: #1976d2;
  color: white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.rbc-toolbar button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.3);
}

.rbc-month-view {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.rbc-month-row {
  border-top: 1px solid #e0e0e0;
}

.rbc-day-bg {
  transition: background-color 0.2s;
}

.rbc-day-bg:hover {
  background-color: #f5f5f5;
}

.rbc-off-range-bg {
  background-color: #fafafa;
}

.rbc-current-time-indicator {
  background-color: #f44336;
  height: 2px;
}

.rbc-time-slot {
  border-top: 1px solid #f0f0f0;
}

.rbc-time-header-content {
  border-left: 1px solid #e0e0e0;
}

.rbc-time-content {
  border-top: 2px solid #e0e0e0;
}

/* Agenda view */
.rbc-agenda-view {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}

.rbc-agenda-table {
  border-spacing: 0;
}

.rbc-agenda-time-cell {
  padding: 8px 12px;
  white-space: nowrap;
}

.rbc-agenda-event-cell {
  padding: 8px 12px;
}

.rbc-agenda-date-cell {
  padding: 8px 12px;
  font-weight: 500;
}

/* Week and Day view */
.rbc-time-slot {
  min-height: 40px;
}

.rbc-timeslot-group {
  border-bottom: 1px solid #e0e0e0;
}

.rbc-time-header {
  border-bottom: 2px solid #e0e0e0;
}

.rbc-header + .rbc-header {
  border-left: 1px solid #e0e0e0;
}

.rbc-rtl .rbc-header + .rbc-header {
  border-left-width: 0;
  border-right: 1px solid #e0e0e0;
}

.rbc-day-slot .rbc-time-slot {
  border-top: 1px solid #f0f0f0;
}

/* Event colors by status */
.rbc-event.rbc-event-pendente {
  background-color: #ff9800 !important;
}

.rbc-event.rbc-event-em_andamento {
  background-color: #2196f3 !important;
}

.rbc-event.rbc-event-concluido {
  background-color: #4caf50 !important;
}

.rbc-event.rbc-event-cancelado {
  background-color: #f44336 !important;
}

/* Selected event */
.rbc-event.rbc-selected {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* Show more link */
.rbc-show-more {
  background-color: transparent;
  color: #1976d2;
  font-weight: 500;
  padding: 2px 5px;
  text-decoration: none;
}

.rbc-show-more:hover {
  text-decoration: underline;
}

/* Tema escuro (.agenda-dark no calendário, pages/Agenda/index.js).
   Hoje, fora do mês, hover do dia, cabeçalho e botões já ficam escuros pelo makeStyles do
   componente; aqui entram as bordas claras e os fundos brancos que sobravam (react-big-calendar + este arquivo). */
.agenda-dark .rbc-header + .rbc-header,
.agenda-dark .rbc-time-view,
.agenda-dark .rbc-time-header > .rbc-row:first-child,
.agenda-dark .rbc-time-header > .rbc-row.rbc-row-resource,
.agenda-dark .rbc-time-header-content > .rbc-row.rbc-row-resource,
.agenda-dark .rbc-time-content > * + * > *,
.agenda-dark .rbc-time-view .rbc-allday-cell + .rbc-allday-cell,
.agenda-dark .rbc-agenda-view table.rbc-agenda-table,
.agenda-dark .rbc-agenda-view table.rbc-agenda-table thead > tr > th,
.agenda-dark .rbc-agenda-view table.rbc-agenda-table tbody > tr + tr,
.agenda-dark .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td,
.agenda-dark .rbc-time-view-resources .rbc-time-header-gutter {
  border-color: #888888;
}

/* Mesmo tom da borda superior de .rbc-time-content (makeStyles) */
.agenda-dark .rbc-time-header {
  border-bottom-color: #444444;
}

.agenda-dark .rbc-time-header.rbc-overflowing {
  border-left-color: #888888;
  border-right-color: #888888;
}

.agenda-dark .rbc-time-slot,
.agenda-dark .rbc-day-slot .rbc-time-slot {
  border-top-color: rgba(255, 255, 255, 0.12);
}

.agenda-dark .rbc-overlay {
  background-color: #424242;
  border-color: rgba(255, 255, 255, 0.12);
}

.agenda-dark .rbc-overlay-header {
  border-bottom-color: rgba(255, 255, 255, 0.12);
}

.agenda-dark .rbc-time-view-resources .rbc-time-gutter,
.agenda-dark .rbc-time-view-resources .rbc-time-header-gutter {
  background-color: #424242;
}

/* O CSS padrão pinta o texto dos botões de #373a3c no hover/foco/clique */
.agenda-dark .rbc-toolbar button:hover,
.agenda-dark .rbc-toolbar button:focus,
.agenda-dark .rbc-toolbar button:active:hover,
.agenda-dark .rbc-toolbar button:active:focus {
  color: #e0e0e0;
}

/* Responsive */
@media (max-width: 768px) {
  .rbc-toolbar {
    flex-direction: column;
    align-items: center;
  }

  .rbc-toolbar-label {
    margin: 10px 0;
  }

  .rbc-header {
    padding: 5px 2px;
    font-size: 0.75rem;
  }

  .rbc-event {
    font-size: 0.7rem;
    padding: 1px 3px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Agenda/agenda.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,wCAAwC;AAC1C;;AAEA,mBAAmB;AACnB;EACE,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;mHAEmH;AACnH;;;;;;;;;;;;EAYE,qBAAqB;AACvB;;AAEA,kEAAkE;AAClE;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,0EAA0E;AAC1E;;;;EAIE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":["/* Estilos para o React Big Calendar */\n.rbc-calendar {\n  font-family: 'Roboto', sans-serif;\n}\n\n.rbc-event {\n  padding: 2px 5px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: opacity 0.2s, transform 0.1s;\n  font-size: 0.85rem;\n  border: none !important;\n}\n\n.rbc-event:hover {\n  opacity: 0.9;\n  transform: scale(1.02);\n}\n\n.rbc-event-label {\n  font-size: 0.75rem;\n}\n\n.rbc-today {\n  background-color: #e3f2fd !important;\n}\n\n.rbc-header {\n  padding: 10px 5px;\n  font-weight: 500;\n  font-size: 0.9rem;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.rbc-toolbar {\n  padding: 10px 0;\n  margin-bottom: 10px;\n}\n\n.rbc-toolbar button {\n  color: #1976d2;\n  border: 1px solid #1976d2;\n  padding: 6px 12px;\n  margin: 0 3px;\n  border-radius: 4px;\n  background-color: white;\n  font-size: 0.875rem;\n  transition: all 0.2s;\n}\n\n.rbc-toolbar button:hover {\n  background-color: #e3f2fd;\n  border-color: #1565c0;\n}\n\n.rbc-toolbar button:active,\n.rbc-toolbar button.rbc-active {\n  background-color: #1976d2;\n  color: white;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.rbc-toolbar button:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.3);\n}\n\n.rbc-month-view {\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.rbc-month-row {\n  border-top: 1px solid #e0e0e0;\n}\n\n.rbc-day-bg {\n  transition: background-color 0.2s;\n}\n\n.rbc-day-bg:hover {\n  background-color: #f5f5f5;\n}\n\n.rbc-off-range-bg {\n  background-color: #fafafa;\n}\n\n.rbc-current-time-indicator {\n  background-color: #f44336;\n  height: 2px;\n}\n\n.rbc-time-slot {\n  border-top: 1px solid #f0f0f0;\n}\n\n.rbc-time-header-content {\n  border-left: 1px solid #e0e0e0;\n}\n\n.rbc-time-content {\n  border-top: 2px solid #e0e0e0;\n}\n\n/* Agenda view */\n.rbc-agenda-view {\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n}\n\n.rbc-agenda-table {\n  border-spacing: 0;\n}\n\n.rbc-agenda-time-cell {\n  padding: 8px 12px;\n  white-space: nowrap;\n}\n\n.rbc-agenda-event-cell {\n  padding: 8px 12px;\n}\n\n.rbc-agenda-date-cell {\n  padding: 8px 12px;\n  font-weight: 500;\n}\n\n/* Week and Day view */\n.rbc-time-slot {\n  min-height: 40px;\n}\n\n.rbc-timeslot-group {\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.rbc-time-header {\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.rbc-header + .rbc-header {\n  border-left: 1px solid #e0e0e0;\n}\n\n.rbc-rtl .rbc-header + .rbc-header {\n  border-left-width: 0;\n  border-right: 1px solid #e0e0e0;\n}\n\n.rbc-day-slot .rbc-time-slot {\n  border-top: 1px solid #f0f0f0;\n}\n\n/* Event colors by status */\n.rbc-event.rbc-event-pendente {\n  background-color: #ff9800 !important;\n}\n\n.rbc-event.rbc-event-em_andamento {\n  background-color: #2196f3 !important;\n}\n\n.rbc-event.rbc-event-concluido {\n  background-color: #4caf50 !important;\n}\n\n.rbc-event.rbc-event-cancelado {\n  background-color: #f44336 !important;\n}\n\n/* Selected event */\n.rbc-event.rbc-selected {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n/* Show more link */\n.rbc-show-more {\n  background-color: transparent;\n  color: #1976d2;\n  font-weight: 500;\n  padding: 2px 5px;\n  text-decoration: none;\n}\n\n.rbc-show-more:hover {\n  text-decoration: underline;\n}\n\n/* Tema escuro (.agenda-dark no calendário, pages/Agenda/index.js).\n   Hoje, fora do mês, hover do dia, cabeçalho e botões já ficam escuros pelo makeStyles do\n   componente; aqui entram as bordas claras e os fundos brancos que sobravam (react-big-calendar + este arquivo). */\n.agenda-dark .rbc-header + .rbc-header,\n.agenda-dark .rbc-time-view,\n.agenda-dark .rbc-time-header > .rbc-row:first-child,\n.agenda-dark .rbc-time-header > .rbc-row.rbc-row-resource,\n.agenda-dark .rbc-time-header-content > .rbc-row.rbc-row-resource,\n.agenda-dark .rbc-time-content > * + * > *,\n.agenda-dark .rbc-time-view .rbc-allday-cell + .rbc-allday-cell,\n.agenda-dark .rbc-agenda-view table.rbc-agenda-table,\n.agenda-dark .rbc-agenda-view table.rbc-agenda-table thead > tr > th,\n.agenda-dark .rbc-agenda-view table.rbc-agenda-table tbody > tr + tr,\n.agenda-dark .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td,\n.agenda-dark .rbc-time-view-resources .rbc-time-header-gutter {\n  border-color: #888888;\n}\n\n/* Mesmo tom da borda superior de .rbc-time-content (makeStyles) */\n.agenda-dark .rbc-time-header {\n  border-bottom-color: #444444;\n}\n\n.agenda-dark .rbc-time-header.rbc-overflowing {\n  border-left-color: #888888;\n  border-right-color: #888888;\n}\n\n.agenda-dark .rbc-time-slot,\n.agenda-dark .rbc-day-slot .rbc-time-slot {\n  border-top-color: rgba(255, 255, 255, 0.12);\n}\n\n.agenda-dark .rbc-overlay {\n  background-color: #424242;\n  border-color: rgba(255, 255, 255, 0.12);\n}\n\n.agenda-dark .rbc-overlay-header {\n  border-bottom-color: rgba(255, 255, 255, 0.12);\n}\n\n.agenda-dark .rbc-time-view-resources .rbc-time-gutter,\n.agenda-dark .rbc-time-view-resources .rbc-time-header-gutter {\n  background-color: #424242;\n}\n\n/* O CSS padrão pinta o texto dos botões de #373a3c no hover/foco/clique */\n.agenda-dark .rbc-toolbar button:hover,\n.agenda-dark .rbc-toolbar button:focus,\n.agenda-dark .rbc-toolbar button:active:hover,\n.agenda-dark .rbc-toolbar button:active:focus {\n  color: #e0e0e0;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .rbc-toolbar {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .rbc-toolbar-label {\n    margin: 10px 0;\n  }\n\n  .rbc-header {\n    padding: 5px 2px;\n    font-size: 0.75rem;\n  }\n\n  .rbc-event {\n    font-size: 0.7rem;\n    padding: 1px 3px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
